import React, { useState, useContext } from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useClientTicketSubmit from "../../hooks/useClientTicketSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import TicketService from "../../services/TicketService";
import DropDownService from "../../services/DropDownService";
import Uploader from "../../components/imageuploader/Uploader";
import { allContext } from "../../context/AllContext";
import TableLoading from "../../components/Loading/TableLoading";

function ClientTicketsView() {

    const [ticketId, setTicketId] = useState("");
    const [projectId, setProjectId] = useState("");
    const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));


    const { reportSearch, setReportSearch, page, setPage, limit, setLimit } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => TicketService.getAllClientTicket({ projectId: projectId, fromDate: startDate, toDate: endDate, page: page, limit: limit }));
    const { data: projectDropDown, loading: projectDropDownLoading } = useAsync(() => DropDownService.clientProjectDropDown());

    var addPermission = 1;
    var viewPermission = 1;
    var listPermission = 1;

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteTicket,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl,
        setImageUrl,
        viewData } = useClientTicketSubmit(ticketId);

    const handleClearFilter = () => {
        setProjectId("");
        setStartDate(dayjs().format("YYYY-MM-DD"));
        setEndDate(dayjs().format("YYYY-MM-DD"));
        setReportSearch(!reportSearch);
    }

    var columnT = ""

    columnT = [
        {
            name: "SUBJECT",
            selector: (row) => row.subject,
            sortable: true,
            wrap: true,
            cell: row => <div><span className="fw-bold ms-1">{row.subject || "-"}</span></div>,
        },
        {
            name: "PROJECT",
            selector: (row) => row.projectId?.projectName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row?.projectId?.projectName || "-"}</span></div>,
            minWidth: "150px"
        },
        {
            name: "ASSIGNED",
            selector: (row) => row.assigneeId?.employeeName,
            sortable: true,
            cell: row => <div><span className=" ms-1">{row.assigneeId?.employeeName || "-"}</span></div>,
            minWidth: "150px"
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : row.status === "Hold" ? "bg-danger" : row.status === "In Progress" ? "bg-primary" : "bg-warning"}`}>{row.status}</span>
        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setTicketId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {/* {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setTicketId(row?._id); }}><i className="icofont-edit text-success"></i></button>)} */}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Tickets" addPermission={addPermission} renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setTicketId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Tickets</button>
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 pb-4 d-flex justify-content-between">
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    max={endDate}
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3 p-2">
                                <label className="form-label">Select Projects</label>
                                <select className="form-select"
                                    value={projectId}
                                    onChange={(e) => setProjectId(e.target.value)}
                                >
                                    <option value="">--- All Projects ---</option>
                                    {!projectDropDownLoading && projectDropDown?.data?.map((project, index) => (
                                        <option key={index} value={project?.value}>{project?.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="ms-5 mt-4 p-2 py-3 me-2">
                                <button className="btn btn-dark  px-4 me-2" type="submit" onClick={() => handleClearFilter()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                <button className="btn btn-dark  px-4 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                            </div>
                        </div>

                    </div>
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            {listPermission === 1 && (
                                <div className="card">
                                    <div className="card-body">
                                        <DataTable
                                            title={"Tickets"}
                                            columns={columnT}
                                            data={data.data}
                                            defaultSortField="title"
                                            pagination
                                            selectableRows={false}
                                            className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                            highlightOnHover={true}
                                            progressPending={tableLoading}
                                            progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>}

            {/* Ticket view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold"> {viewData?.clientId?.clientName} Tickets Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-4">
                                    <b>  Images </b>
                                </div>
                                <div className="col-sm-8 mb-3">
                                    {viewData?.images && viewData?.images.length !== 0 ? (
                                        viewData?.images.map((img) => (
                                            <img src={img} alt="client" className="h-64 w-64 m-1" style={{ height: '12rem', width: '12rem', objectFit: 'cover' }} crossOrigin="anonymous" />
                                        ))) : (
                                        <img
                                            src="https://res.cloudinary.com/ahossain/image/upload/v1655097002/placeholder_kvepfp.png"
                                            alt="slider"
                                            crossOrigin="anonymous"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Subject </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.subject}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Message </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.message || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Project </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.projectId?.projectName}</div>
                                </div>
                            </div>
                            {/* <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Assigned </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.assigneeId?.employeeName}</div>
                                </div>
                            </div> */}
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.status}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* ticket add and edit modal */}
            <Modal centered show={isModal} onHide={() => { setIsModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{ticketId !== "" ? "Edit" : "Add"} Ticket</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="sub" className="form-label">Subject</label>
                            <InputArea disabled={ticketId} register={register} label={"Name"} name="subject" type="text" className="form-control" id="sub" placeholder="Subject" />
                            <Error errorName={errors?.subject} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Project Name</label>
                            <select className="form-select" disabled={ticketId} {...register(`projectId`, { required: `Project is required!` })}>
                                <option value="" defaultValue >Select Project</option>
                                {!projectDropDownLoading && projectDropDown?.data?.map((project, index) => (
                                    <option key={index} value={project?.value}>{project?.label}</option>
                                ))}
                            </select>
                            <Error errorName={errors?.projectId} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Status</label>
                            <select className="form-select" {...register(`status`, { required: `Status is required!` })}>
                                <option value="Open" defaultValue >Open</option>
                                {ticketId &&
                                    <>
                                        <option value="Hold" >Hold</option>
                                        <option value="In Progress" >In Progress</option>
                                        <option value="Completed">Completed</option>
                                        <option value="Waiting">Waiting</option>
                                        <option value="Decline">Decline</option>
                                    </>}
                            </select>
                            <Error errorName={errors?.status} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="desc" className="form-label">Message</label>
                            <textarea {...register(`message`, { required: false })} name="message" className="form-control" id="desc" rows="3" placeholder="Message"></textarea>
                        </div>
                        <div className="">
                            <label className="form-label">Image</label>
                            <Uploader
                                multiple
                                imageUrl={imageUrl}
                                setImageUrl={setImageUrl}
                                folder="slider"
                                name="image"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{ticketId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* ticket delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Ticket</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Ticket ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteTicket(ticketId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default ClientTicketsView;